import React, {FC, useRef, useEffect} from "react";
import Hotel from "../../modules/hotels/types/Hotel";
import GoogleMapReact from "google-map-react";
import LocationMarker from "../../modules/ui/components/AnyReactComponent/LocationMarker";
import useTranslate from "../../modules/core/languages/hooks/useTranslate";
import {GOOGLE_MAPS_API_KEY} from "../../config/config";
import {useLocation} from "react-router-dom";
import EventCity from "../../modules/eventCities/types/EventCity";
import EventMapPin from "../../pages/PageCityEvent/MainEventCitySection/EventMapPin";

export interface HotelLocationCardProps {
    hotel: Hotel;
    eventCity?: EventCity;
}

const HotelLocationCard: FC<HotelLocationCardProps> = ({
    hotel,
    eventCity,
}) => {
    const t = useTranslate();
    const ref = useRef<HTMLDivElement>(null);
    const location = useLocation();

    useEffect(() => {
        if (location.hash === "#location" && ref.current) {
            ref.current.scrollIntoView({behavior: "smooth"});
        }
    }, [location.hash]);

    return (
        <div ref={ref} className="listingSection__wrap !mt-5">
            {/* HEADING */}
            <div>
                <h2 className="text-2xl font-semibold">{t("hotelDetail.location")}</h2>
                <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                    {hotel.address}
                </span>
            </div>

            {/* MAP */}
            <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3">
                <div className="rounded-xl overflow-hidden">
                    <GoogleMapReact
                        bootstrapURLKeys={{
                            key: GOOGLE_MAPS_API_KEY,
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        defaultZoom={15}
                        defaultCenter={{
                            lat: hotel.lat,
                            lng: hotel.lng,
                        }}
                    >
                        {eventCity && (
                            <EventMapPin
                                isSelected={false}
                                key={eventCity.event}
                                lat={eventCity.lat}
                                lng={eventCity.lng}
                            />
                        )}
                        <LocationMarker lat={hotel.lat} lng={hotel.lng} />
                    </GoogleMapReact>
                </div>
            </div>
        </div>
    );
};

export default HotelLocationCard;
